import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
const Box = t0 => {
  const $ = _c(7);
  const {
    title,
    text
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="text-3xl font-semibold md:text-5xl">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text) {
    t2 = <p className="text-base font-semibold md:text-xl">{text}</p>;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="w-full max-w-[23rem] rounded-xl bg-blue-500 p-6 text-center text-white md:rounded-4xl md:px-7 md:py-8">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const SafeBet = () => {
  const $ = _c(32);
  const {
    t
  } = useTranslation("forEshops");
  let t0;
  if ($[0] !== t) {
    t0 = t("safeBet.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SectionHeadline className="mb-10 px-0 lg:mb-16" anchorKey="safeBet.title">{t0}</SectionHeadline>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("safeBet.items.1.text");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("safeBet.items.1.title");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Box text={t2} title={t3} />;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("safeBet.items.2.text");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("safeBet.items.2.title");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <Box text={t5} title={t6} />;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("safeBet.items.3.text");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("safeBet.items.3.title");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <Box text={t8} title={t9} />;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t4 || $[27] !== t7) {
    t11 = <div className="flex flex-col items-center justify-center gap-2 lg:flex-row lg:gap-8">{t4}{t7}{t10}</div>;
    $[25] = t10;
    $[26] = t4;
    $[27] = t7;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t1 || $[30] !== t11) {
    t12 = <>{t1}{t11}</>;
    $[29] = t1;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};